import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// ❌ Home remove kar diya landing se
// import Home from "./pages/Home";

import Login from "./pages/Login";
import Signup from "./pages/Signup";
import StorePage from "./pages/StorePage";
import AdminCsvUpload from "./pages/AdminCsvUpload";
import Coupon from "./pages/Coupons";
import Categories from "./pages/Categories";

import OurProducts from "./booking_pages/OurProducts";
import ProductDetail from "./booking_pages/ProductDetail";
import CartPage from "./booking_pages/CartPage";
import CheckoutPage from "./booking_pages/CheckoutPage";

import Orders from "./booking_pages/DashBoard/Orders";
import ProfilePage from "./booking_pages/DashBoard/ProfilePage";

// ⭐ AERTH HOME PAGE
import AllProducts from "./booking_pages/DashBoard/Allproducts";

import ManageAddress from "./booking_pages/DashBoard/ManageAddress";
import DashboardLayout from "./booking_pages/DashBoard/DashboardLayout";
import WishlistPage from "./booking_pages/DashBoard/WishlistPage";

function App() {
  const isLoggedIn = !!localStorage.getItem("access_token");

  return (
    <Router>
      <Routes>

        {/* 🏠 NEW LANDING = AERTH PRODUCTS PAGE */}
        <Route path="/" element={<AllProducts />} />
        <Route path="/home" element={<AllProducts />} />
        <Route path="/all-products" element={<AllProducts />} />

        {/* 🏬 Store page */}
        <Route path="/stores/:slug" element={<StorePage />} />

        {/* 📚 Public pages */}
        <Route path="/categories" element={<Categories />} />
        <Route path="/coupons" element={<Coupon />} />

        {/* 🔐 Auth */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />

        {/* 🧾 Admin CSV Upload */}
        <Route
          path="/admin/upload-csv"
          element={isLoggedIn ? <AdminCsvUpload /> : <Navigate to="/login" replace />}
        />

        {/* 🛍️ E-Commerce */}
        <Route path="/products" element={<OurProducts />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/orders" element={<Orders />} />

        {/* ⭐ USER DASHBOARD */}
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route path="profile" element={<ProfilePage />} />
          <Route path="address" element={<ManageAddress />} />
          <Route path="wishlist" element={<WishlistPage />} />
        </Route>

        {/* 🚦 WRONG URL → Go to AERTH Landing */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
